import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import StatusCards from "./StatusCards";
import { useUserContext } from "../../context/UserContext.jsx";
import { LeadJourneyCardSkeleton } from "./skeleton/LeadJourneySkeleton.jsx";

import {
  ColdIcon,
  WarmIcon,
  HotIcon,
  RemittanceIcon,
  InsuranceIcon,
  FinancingIcon,
  ReferralIcon,
  ReKYCIcon,
} from "../lead-inventory/icons";
import RejectLeadButton from "./RejectLeadButton";
import PickLeadButton from "../lead-inventory/shark_tank/pickLead.jsx";

export const LeadJourneySquare = ({ leadDetails, leadOwner, onRefetch }) => {
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const routeParams = useParams();

  const fromLeadTable = false;

  const role = localStorage.getItem("role");
  const canViewLead = role === 'HOD_Hunter' || role === 'Admin';


  const leadSourceLabels = {
    0: "Raw Lead",
    1: "Fresh Lead",
    2: "Profile Completed",
    3: "Meeting Completion",
    4: "Onboarded",
    5: "Activated",
    6: "Rejected",
    11: "Tanked",
  };

  const interestLevelLabels = {
    1: "Cold",
    2: "Warm",
    3: "Hot",
  };

  const getStatusStyle = (status) => {
    const styles = {
      0: "bg-gray-100 text-gray-600",
      1: "bg-[#FEFAD8] border-[#FEFAD8] text-black",
      2: "bg-[#BEC2FF] border-[#BEC2FF] text-[#262BC6]",
      3: "bg-[#E3F3FF] border-[#E3F3FF] text-[#00658E]",
      4: "bg-[#E7FFD6] border-[#E7FFD6] text-[#116D26]",
      5: "bg-[#E7FFD6] border-[#E7FFD6] text-[#116D26]",
      6: "bg-red-100 text-red-500",
      11: "bg-red-200 text-red-800",
    };
    return styles[status] || "bg-gray-100 text-gray-600";
  };
  const getLeadStatusStyle = (status) => {
    const styles = {
      Active: "bg-[#FEFAD8] border-[#FEFAD8] text-black",
      Ongoing: "bg-[#FFEEDC] border-[#FFEEDC] text-[#A96900]",
      Inactive: "bg-[#EEEEEE] border-[#EEEEEE] text-[#757575]",
      Tanked: "bg-[#757575] border-[#757575] text-[#EEEEEE]",
    };
    return styles[status] || "bg-gray-100 text-gray-600";
  };

  let cards = [
    { title: "Fresh Lead", status: "completed", statusLabel: "Completed" },
    {
      title: "Profile Completion",
      status: "in-progress",
      statusLabel: "In Progress",
    },
    {
      title: "Meeting Completion",
      status: "not-started",
      statusLabel: "Not Started",
    },
    { title: "Conversion", status: "not-started", statusLabel: "Not Started" },
  ];

  // Default status if leadDetails doesn't exist or has no status
  if (!leadDetails || typeof leadDetails.status !== "number") {
    // Use the default cards array above
    let cards = [
      { title: "Fresh Lead", status: "completed", statusLabel: "Completed" },
      {
        title: "Profile Completion",
        status: "in-progress",
        statusLabel: "In Progress",
      },
      {
        title: "Meeting Completion",
        status: "not-started",
        statusLabel: "Not Started",
      },
      {
        title: "Conversion",
        status: "not-started",
        statusLabel: "Not Started",
      },
    ];
  }
  // Status 0,1: Fresh Lead completed, Profile Completion in progress
  else if (
    leadDetails.product_status === 1 ||
    leadDetails.product_status === 0
  ) {
    cards = [
      { title: "Fresh Lead", status: "completed", statusLabel: "Completed" },
      {
        title: "Profile Completion",
        status: "in-progress",
        statusLabel: "In Progress",
      },
      {
        title: "Meeting Completion",
        status: "not-started",
        statusLabel: "Not Started",
      },
      {
        title: "Conversion",
        status: "not-started",
        statusLabel: "Not Started",
      },
    ];
  }else if (leadDetails.product_status === 2) {
    cards = [
      { title: "Fresh Lead", status: "completed", statusLabel: "Completed" },
      {
        title: "Profile Completion",
        status: "completed",
        statusLabel: "Completed",
      },
      {
        title: "Meeting Completion",
        status: "in-progress",
        statusLabel: "In Progress",
      },
      {
        title: "Conversion",
        status: "not-started",
        statusLabel: "Not Started",
      },
    ];
  }
  // Status 4: Meeting completed, Conversion in progress
  else if (leadDetails.product_status === 3) {
    cards = [
      { title: "Fresh Lead", status: "completed", statusLabel: "Completed" },
      {
        title: "Profile Completion",
        status: "completed",
        statusLabel: "Completed",
      },
      {
        title: "Meeting Completion",
        status: "completed",
        statusLabel: "Completed",
      },
      {
        title: "Conversion",
        status: "in-progress",
        statusLabel: "In Progress",
      },
    ];
  }
  // Status 5: All completed
  else if (leadDetails.product_status === 4) {
    cards = [
      { title: "Fresh Lead", status: "completed", statusLabel: "Completed" },
      {
        title: "Profile Completion",
        status: "completed",
        statusLabel: "Completed",
      },
      {
        title: "Meeting Completion",
        status: "completed",
        statusLabel: "Completed",
      },
      { title: "Conversion", status: "in-progress", statusLabel: "Compliance Reviewing" },
    ];
  }else if(leadDetails.product_status === 6){
    cards = [
      { title: "Fresh Lead", status: "completed", statusLabel: "Completed" },
      {
        title: "Profile Completion",
        status: "completed",
        statusLabel: "Completed",
      },
      {
        title: "Meeting Completion",
        status: "completed",
        statusLabel: "Completed",
      },
      { title: "Conversion", status: "in-progress", statusLabel: "Onboarded" },
    ];
  }else if(leadDetails.product_status === 7 || leadDetails.product_status === 8){
    cards = [
      { title: "Fresh Lead", status: "completed", statusLabel: "Completed" },
      {
        title: "Profile Completion",
        status: "completed",
        statusLabel: "Completed",
      },
      {
        title: "Meeting Completion",
        status: "completed",
        statusLabel: "Completed",
      },
      { title: "Conversion", status: "completed", statusLabel: "Activated" },
    ];
  }

  const tabs = ["Remittance"];

  // Render nothing if leadDetails is null
  if (!leadDetails) {
    return (
      <LeadJourneyCardSkeleton/>
    ) // Or a loading spinner
  }

  return (
    <div className="w-full">
      {/* Outer White Container */}
      <div className="bg-white rounded-2xl md:rounded-3xl shadow-sm p-4 md:p-6 mx-2 md:mx-8 mt-3 md:mt-5">
        <p className="font-light ml-1 text-xs md:text-sm">Lead #{leadDetails?.lead_id}</p>
        <p className="font-extrabold text-xl md:text-4xl mt-2 mb-4 md:mb-2 ml-1 break-words">
          <b>{leadDetails?.name || "Unknown Company"}</b>
        </p>
        <p className="font-light ml-1 text-xs md:text-sm md:mb-6">Created by {leadDetails?.created_by} at {leadDetails?.created_at} </p>
        {/* <p className="font-light ml-1 text-xs md:text-sm md:mb-4">Created by {leadDetails?.created_by}</p> */}
        <div className="flex flex-row gap-2 overflow-x-auto scrollbar-hide pb-2">
          <span
            className={`w-auto h-[36px] md:h-[40px] py-1.5 md:py-2 px-2 md:px-3 gap-1 md:gap-2 font-bold flex-shrink-0`}
          >
            {leadDetails?.product_type?.includes("Remittance") && (
              <img
                key={`remittance-${leadDetails.lead_id}`}
                src={RemittanceIcon}
                alt="Remittance"
                className="inline-block w-5 h-5 md:w-6 md:h-6 mr-1 md:mr-2"
              />
            )}
            {leadDetails?.product_type?.includes("Insurance") && (
              <img
                key={`insurance-${leadDetails.lead_id}`}
                src={InsuranceIcon}
                alt="Insurance"
                className="inline-block w-5 h-5 md:w-6 md:h-6 mr-1 md:mr-2"
              />
            )}
            {leadDetails?.product_type?.includes("Financing") && (
              <img
                key={`financing-${leadDetails.lead_id}`}
                src={FinancingIcon}
                alt="Financing"
                className="inline-block w-5 h-5 md:w-6 md:h-6 mr-1 md:mr-2"
              />
            )}
            {leadDetails?.product_type?.includes("Referral") && (
              <img
                key={`referral-${leadDetails.lead_id}`}
                src={ReferralIcon}
                alt="Referral"
                className="inline-block w-5 h-5 md:w-6 md:h-6 mr-1 md:mr-2"
              />
            )}
            {leadDetails?.product_type?.includes("Re-KYC") && (
              <img
                key={`rekyc-${leadDetails.lead_id}`}
                src={ReKYCIcon}
                alt="ReKYC"
                className="inline-block w-5 h-5 md:w-6 md:h-6 mr-1 md:mr-2"
              />
            )}
          </span>
          <span
            className={`w-auto h-[36px] md:h-[40px] py-1.5 md:py-2 px-3 md:px-5 gap-1 md:gap-2 rounded-full border font-bold text-xs md:text-sm flex-shrink-0 ${getStatusStyle(
              leadDetails.status
            )}`}
          >
            {leadSourceLabels[leadDetails?.status] || "Unknown"}
          </span>
          <span
            className={`w-auto h-[36px] md:h-[40px] py-1.5 md:py-2 px-3 md:px-5 gap-1 md:gap-2 rounded-full border font-bold text-xs md:text-sm flex-shrink-0 ${getLeadStatusStyle(
              leadDetails?.lead_status
            )}`}
          >
            {leadDetails?.lead_status}
          </span>
          <span className="w-auto h-[36px] md:h-[40px] py-1.5 md:py-2 px-3 md:px-5 gap-1 md:gap-2 flex items-center rounded-full border font-bold text-xs md:text-sm bg-[#EEEEEE] border-[#EEEEEE] text-[#1E293B] flex-shrink-0">
            {leadDetails?.interest_level === 1 && (
              <img
                src={ColdIcon}
                alt="Cold"
                className="w-5 h-5 md:w-6 md:h-6 inline-block"
              />
            )}
            {leadDetails?.interest_level === 2 && (
              <img
                src={WarmIcon}
                alt="Warm"
                className="w-5 h-5 md:w-6 md:h-6 inline-block"
              />
            )}
            {leadDetails?.interest_level === 3 && (
              <img
                src={HotIcon}
                alt="Hot"
                className="w-5 h-5 md:w-6 md:h-6 inline-block"
              />
            )}
            {interestLevelLabels[leadDetails?.interest_level] || "Unknown"}
          </span>
        </div>

        {/* Inner Grey Container */}
        <div className="bg-gray-100 p-3 md:p-4 rounded-2xl md:rounded-3xl border-opacity-20 border-2">
          {/* Tabs Container */}
          <div className="flex space-x-4 md:space-x-6 overflow-x-auto scrollbar-hide">
            {tabs.map((tab, index) => (
              <button
                key={index}
                onClick={() => setActiveTab(index)}
                className={`relative text-sm md:text-md font-medium pb-2 transition-all whitespace-nowrap flex-shrink-0 ${
                  activeTab === index
                    ? "text-black border-b-4 border-yellow-300 w-20 md:w-24"
                    : "text-gray-500"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Dynamic Content Based on Active Tab */}
          {activeTab === 0 && (
            <div>
              <div className="w-full flex flex-col md:flex-row md:justify-between md:items-center gap-3 md:gap-0 mt-3 bg-gray-100 rounded-lg">
                {/* Left Section: Icon and Text */}
                <div className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="h-5 w-5 md:h-6 md:w-6 mr-2 md:mr-4 flex-shrink-0"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9.348 14.652a3.75 3.75 0 0 1 0-5.304m5.304 0a3.75 3.75 0 0 1 0 5.304m-7.425 2.121a6.75 6.75 0 0 1 0-9.546m9.546 0a6.75 6.75 0 0 1 0 9.546M5.106 18.894c-3.808-3.807-3.808-9.98 0-13.788m13.788 0c3.808 3.807 3.808 9.98 0 13.788M12 12h.008v.008H12V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
                    />
                  </svg>
                  <p className="font-bold text-lg md:text-2xl">Pipeline Progress</p>
                </div>

                {/* Show reject option if lead belongs to current user */}
                {leadOwner || canViewLead ? (
                  (canViewLead && leadDetails?.status !== 6) ||
                  (leadOwner && ![4, 5, 6].includes(leadDetails?.status)) ? (
                    <div className="p-0 md:p-8">
                      <RejectLeadButton
                        leadID={leadDetails.lead_id}
                        onRefetch={onRefetch}
                      />
                    </div>
                  ) : null
                ) : leadDetails?.lead_status === "Tanked" &&
                  ![4, 5, 6].includes(leadDetails?.status) ? (
                  <div className="p-0 md:p-8">
                    <PickLeadButton
                      leadId={leadDetails.lead_id}
                      leadName={leadDetails?.name}
                      fromLeadTable={fromLeadTable}
                    />
                  </div>
                ) : null}
              </div>

              <div className=" bg-gray-100">
                <StatusCards cards={cards} />
              </div>
            </div>
          )}

          {activeTab === 1 && (
            <div className="w-full shadow-lg p-4 bg-gray-100 rounded-lg">
              <h2 className="font-bold">Insurance Section</h2>
              <p>This is the content for the Insurance tab.</p>
            </div>
          )}

          {activeTab === 2 && (
            <div className="w-full shadow-lg p-4 bg-gray-100 rounded-lg">
              <h2 className="font-bold">Other Section</h2>
              <p>This is the content for the Other tab.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeadJourneySquare;
